import { Link } from "react-router-dom";
import { MapPin, Calendar, Clock, Heart } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { formatDateIt, placeOf } from "../lib/constants";
import { RecurrenceBadge } from "./RecurrenceBadge";
import { TonightBadge } from "./TonightBadge";

export const EventCard = ({ event, index = 0, isFavorite, onToggleFavorite }) => {
  const img = mediaUrl(event.image_url) || "https://static.prod-images.emergentagent.com/jobs/0318cc04-21bf-446a-8df6-374fe4adb994/images/75804f2344241a9c7d1f939d0784a62a8eb3d108fda6e83123d409f5cdb1bd9f.png";
  return (
    <div
      data-testid={`event-card-${event.id}`}
      className="group relative rounded-2xl overflow-hidden bg-wyd-surface border border-white/10 hover:-translate-y-1 hover:glow-magenta transition-transform duration-300 fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 480)}ms` }}
    >
      <Link to={`/evento/${event.id}`} data-testid={`event-card-link-${event.id}`}>
        <div className="relative h-52 overflow-hidden">
          <img src={img} alt={event.title} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-t from-wyd-bg via-wyd-bg/40 to-transparent" />
          <span className="absolute top-3 left-3 overline text-wyd-bg bg-wyd-accent/95 px-3 py-1 rounded-full">
            {event.category}
          </span>
          <TonightBadge date={event.date} testid={`tonight-badge-${event.id}`} className="absolute bottom-3 left-3" />
        </div>
      </Link>

      {onToggleFavorite && (
        <button
          data-testid={`favorite-btn-${event.id}`}
          onClick={() => onToggleFavorite(event.id)}
          className="absolute top-3 right-3 w-9 h-9 rounded-full grid place-items-center glass hover:scale-110 transition-transform duration-200"
          aria-label="Preferito"
        >
          <Heart size={16} className={isFavorite ? "fill-wyd-accent text-wyd-accent" : "text-white"} />
        </button>
      )}

      <div className="p-5">
        <Link to={`/evento/${event.id}`}>
          <h3 className="font-display font-bold text-lg text-white leading-snug group-hover:text-wyd-accent transition-colors duration-200 line-clamp-2">
            {event.title}
          </h3>
        </Link>
        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5 text-sm text-wyd-muted">
          {placeOf(event) && <span className="flex items-center gap-1.5" data-testid={`event-card-place-${event.id}`}><MapPin size={14} className="text-wyd-accent" /> {placeOf(event)}</span>}
          <span className="flex items-center gap-1.5"><Calendar size={14} className="text-wyd-accent" /> {formatDateIt(event.date)}</span>
          {event.time && <span className="flex items-center gap-1.5"><Clock size={14} className="text-wyd-accent" /> {event.time}</span>}
        </div>
        <RecurrenceBadge label={event.recurrence_label} testid={`recurrence-badge-${event.id}`} className="mt-3" />
        <div className="mt-4 flex items-center justify-between">
          <span className="font-display font-bold text-wyd-accent">{event.price || "Gratis"}</span>
          {event.distance_km != null && (
            <span className="text-xs text-wyd-muted">{event.distance_km} km da te</span>
          )}
        </div>
      </div>
    </div>
  );
};
